// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__2HYam","right":"styles_right__2y3YP"};